const RelatedLinks = (props) => {
    const relatedLinksList = props.relatedLinksList;

    return (
        <>
        <div className="card-tile-box">
        <h2>Administrative Tools</h2>
            {relatedLinksList.map((item, index) => {
                return (
                    <div key={index} className="relative">
                        <a href={item.link} target="_blank">{item.title}</a>
                        <p>{item.description}</p>
                    </div>
                
                );
            })}
            </div> 
        </> 
        
  
       
    );

}

export default RelatedLinks;